export const LEFT_POSITION_STYLE = 'left';
export const RIGHT_POSITION_STYLE = 'right';
